import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import Modal from '../../components/Modal';
import styles from './MobileSearchModal.module.scss';

function MobileSearchModal(props) {
  const { open, onClose, children, ...rest } = props;

  const [height, setHeight] = useState(window.innerHeight);

  const updateDimensions = () => {
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  return (
    <Modal
      className={cx(styles.searchModal)}
      styles={{ modal: { maxHeight: `${height - 64}px` }, modalContainer: { overflowY: 'hidden' } }}
      open={open}
      onClose={onClose}
      {...rest}
    >
      {children}
    </Modal>
  );
}

export default MobileSearchModal;
